import { Button, Col, Divider, Drawer, Row, Tooltip, Upload } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import axios from "axios";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import EditBusiness from "./EditBusiness";
import EditContact from "./EditContact";
import EditPersonal from "./EditPersonal";
import EditCredentials from "./EditCredentials";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

const PasswordItem = () => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">Password:</p>
    &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
  </div>
);

const AccountDetails = ({ open, close }) => {
  const { userData, handleRerunUser } = useContext(UserInfo);
  const [commissaryInfo, setCommissaryInfo] = useState({
    data: [],
    ready: false,
  });
  const [editPersonal, setEditPersonal] = useState(false);
  const [editBusiness, setEditBusiness] = useState(false);
  const [editContact, setEditContact] = useState(false);
  const [editCredentials, setEditCredentials] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const getMyCommissaryInfo = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/my-commissary-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setCommissaryInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMyCommissaryInfo();
  }, [getMyCommissaryInfo]);

  const props = {
    listType: "picture-card",
  };

  const handleUploadLogo = ({ file }) => {
    // console.log("file", file);
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("file", file);
    axios
      .post("user/commissary/upload-logo", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Uploaded logo successfully.");
          setTimeout(() => {
            handleRerunUser();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const handleUploadCover = ({ file }) => {
    // console.log("file", file);
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("file", file);
    axios
      .post("user/commissary/upload-cover", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Uploaded cover successfully.");
          setTimeout(() => {
            handleRerunUser();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                close();
              }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      {commissaryInfo.ready && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="site-description-item-profile-p">Cover</p>
          </div>
          <Row>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <Upload
                    fileList={[
                      {
                        uid: "1",
                        name:
                          userData.data.userscominfo.business_cover !== null
                            ? userData.data.userscominfo.business_cover
                            : "default-cover.png",
                        status: "done",
                        url:
                          userData.data.userscominfo.business_cover !== null
                            ? `${process.env.REACT_APP_API_IMAGE}cover/${userData.data.userscominfo.business_cover}`
                            : require("./../../../assets/900x300logo.png"),
                      },
                    ]}
                    multiple={false}
                    listType="picture-card"
                    maxCount={1}
                    showUploadList={{
                      showRemoveIcon: false,
                    }}
                    customRequest={handleUploadCover}
                  >
                    Upload
                  </Upload>
                </div>
              </div>
            </Col>
          </Row>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="site-description-item-profile-p">Logo</p>
          </div>
          <Row>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <ImgCrop rotationSlider>
                    <Upload
                      {...props}
                      fileList={[
                        {
                          uid: "1",
                          name:
                            userData.data.userscominfo.business_logo !== null
                              ? userData.data.userscominfo.business_logo
                              : "default-logo.png",
                          status: "done",
                          url:
                            userData.data.userscominfo.business_logo !== null
                              ? `${process.env.REACT_APP_API_IMAGE}logo/${userData.data.userscominfo.business_logo}`
                              : require("./../../../assets/logo.png"),
                        },
                      ]}
                      showUploadList={{
                        showRemoveIcon: false,
                      }}
                      customRequest={handleUploadLogo}
                    >
                      Upload
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </Col>
          </Row>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Personal</p>
            </div>
            <div>
              <Tooltip title="Edit Personal">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    // setSelectedData(text);
                    setEditPersonal(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Full Name"
                content={`${commissaryInfo.data[0].reg_firstname} ${commissaryInfo.data[0].reg_lastname}`}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Address"
                content={`${commissaryInfo.data[0].reg_street}, ${
                  commissaryInfo.data[0].reg_barangay
                }, ${commissaryInfo.data[0].reg_city.toLowerCase()}, ${commissaryInfo.data[0].reg_province.toLowerCase()}`}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Business</p>
            </div>
            <div>
              <Tooltip title="Edit Business">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditBusiness(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Business Name"
                content={`${commissaryInfo.data[0].business_name}`}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Business Address"
                content={`${commissaryInfo.data[0].business_street}, ${
                  commissaryInfo.data[0].business_barangay
                }, ${commissaryInfo.data[0].business_city.toLowerCase()}, ${commissaryInfo.data[0].business_province.toLowerCase()}`}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Contacts</p>
            </div>
            <div>
              <Tooltip title="Edit Contacts">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditContact(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={12}>
              <DescriptionItem
                title="Email"
                content={commissaryInfo.data[0].cominfouser.email}
              />
            </Col>
            <Col span={12}>
              <DescriptionItem
                title="Contact Number"
                content={commissaryInfo.data[0].reg_contact_no}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Credentials</p>
            </div>
            <div>
              <Tooltip title="Edit Credentials">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditCredentials(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={12}>
              <DescriptionItem
                title="Username"
                content={commissaryInfo.data[0].cominfouser.username}
              />
            </Col>
            <Col span={12}>
              <PasswordItem />
            </Col>
          </Row>
        </>
      )}

      {editPersonal && (
        <EditPersonal
          open={editPersonal}
          close={() => setEditPersonal(false)}
          data={commissaryInfo.ready && commissaryInfo.data[0]}
          getMyCommissaryInfo={() => getMyCommissaryInfo()}
        />
      )}

      {editBusiness && (
        <EditBusiness
          open={editBusiness}
          close={() => setEditBusiness(false)}
          data={commissaryInfo.ready && commissaryInfo.data[0]}
          getMyCommissaryInfo={() => getMyCommissaryInfo()}
        />
      )}

      {editContact && (
        <EditContact
          open={editContact}
          close={() => setEditContact(false)}
          data={commissaryInfo.ready && commissaryInfo.data[0]}
          getMyCommissaryInfo={() => getMyCommissaryInfo()}
        />
      )}

      {editCredentials && (
        <EditCredentials
          open={editCredentials}
          close={() => setEditCredentials(false)}
          data={commissaryInfo.ready && commissaryInfo.data[0]}
          getMyCommissaryInfo={() => getMyCommissaryInfo()}
        />
      )}
    </Drawer>
  );
};

export default AccountDetails;
